import {axios} from '@js/utilities/axios.js';
export default {
	namespaced: true,
	state: {
		zones: []
	},
	actions: {
		fetch(context) {
			return new Promise((resolve, reject) => {
				axios.get('/api/zones').then((rsp) => {
					context.commit('setAllZones', rsp.data.data)
					resolve(rsp);
				}).catch(err => reject(err))
			})
		}
	},
	mutations: {
		setAllZones(state, zones) {
			state.zones = zones;
		}
	}
}
